import { render, staticRenderFns } from "./DigitalOrderCreate.vue?vue&type=template&id=4fc39624&scoped=true"
import script from "./DigitalOrderCreate.vue?vue&type=script&lang=js"
export * from "./DigitalOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./DigitalOrderCreate.vue?vue&type=style&index=0&id=4fc39624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc39624",
  null
  
)

export default component.exports